import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import SpeakingPracticeMain from './SpeakingPracticeMain';
import SpeakingPracticeExpended from './SpeakingPracticeExpended';

const activityProps = {
    defaultVolume: 0.5,
    defaultWidth: 1240,
    defaultHeight: 840,
    characterMediaPath: window.location.origin + "/character/",
    textHighlightFontSize: 48,
    textFontSize: 32,
    textColor: '#242424',
    textFontFamily: 'Nanum Barun Gothic',
    textLineHeight: 1.8,
};

const SpeakingPractice = forwardRef((props, ref) => {
    const categorySelected = props.categorySelected;
    const setNextButtonEnabled = props.setNextButtonEnabled;
    const setNextButtonEnabledR = props.setNextButtonEnabledR;
    const pagenum = props.pagenum;
    const mediaPath = props.mediaPath + '/';
    const feedback = props.feedback;
    const recordTimeOverModalRef = props.recordTimeOverModalRef;
    const openAlertModal = props.openAlertModal;
    const answerOpen = props.answerOpen;
    const speakingpracticeRef = props.speakingpracticeRef;
    const isRecording = props.isRecording;
    const miniSitcomSpeakSentenceRef = useRef();
    
    useImperativeHandle(ref, () => ({
        setSelectedSubImage(imagePath) {
            miniSitcomSpeakSentenceRef.current.setSelectedSubImage(imagePath);
        }
    }));

    if (categorySelected.name === "Main Sentence") {
        return <SpeakingPracticeMain
            categorySelected={categorySelected}
            mediaPath={mediaPath}
            activityProps={activityProps}
            pagenum={pagenum}
        />
    } else if (categorySelected.name === "Expended Sentence") {
        return <SpeakingPracticeExpended
            ref={miniSitcomSpeakSentenceRef}
            speakingpracticeRef={speakingpracticeRef}
            categorySelected={categorySelected}
            setNextButtonEnabled={setNextButtonEnabled}
            setNextButtonEnabledR={setNextButtonEnabledR}
            mediaPath={mediaPath}
            openAlertModal={openAlertModal}
            activityProps={activityProps}
            answerOpen={answerOpen}
            isRecording = {isRecording}
        />
    } else {
        return (
            <div>Error</div>
        )
    }
});

export default SpeakingPractice;
